import { Routes } from '@angular/router';

import { ScrollableRouteGuard } from '@app/common/guards/scrollable-route.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('@app/pages/main-page/main-page.component').then((m) => m.MainPageComponent)
  },
  {
    path: 'realizacje/:portfolioItemSlug',
    pathMatch: 'full',
    loadComponent: () => import('@app/pages/portfolio-item-page/portfolio-item-page.component').then((m) => m.PortfolioItemPageComponent)
  },
  {
    path: 'realizacje',
    pathMatch: 'full',
    canActivate: [ScrollableRouteGuard],
    loadComponent: () => import('@app/pages/main-page/main-page.component').then((m) => m.MainPageComponent)
  },
  {
    path: 'proces',
    pathMatch: 'full',
    canActivate: [ScrollableRouteGuard],
    loadComponent: () => import('@app/pages/main-page/main-page.component').then((m) => m.MainPageComponent)
  },
  {
    path: 'faq',
    pathMatch: 'full',
    canActivate: [ScrollableRouteGuard],
    loadComponent: () => import('@app/pages/main-page/main-page.component').then((m) => m.MainPageComponent)
  },
  {
    path: 'kontakt',
    pathMatch: 'full',
    canActivate: [ScrollableRouteGuard],
    loadComponent: () => import('@app/pages/main-page/main-page.component').then((m) => m.MainPageComponent)
  },
  {
    path: 'informacje-prawne',
    pathMatch: 'full',
    loadComponent: () => import('@app/pages/legal-info-page/legal-info-page.component').then((m) => m.LegalInfoPageComponent)
  },
  {
    path: 'polityka-prywatnosci',
    pathMatch: 'full',
    loadComponent: () => import('@app/pages/privacy-policy-page/privacy-policy-page.component').then((m) => m.PrivacyPolicyPageComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
